import React, { memo } from 'react';
import classNames from 'classnames';
import { ContextMenuTrigger } from 'react-contextmenu';

import { isDeepChanged } from '../../../../utils/ChangeSpy';

import style from './style.module.css';

const GeneralFormatComponent = ({ value, data, colDef, rowIndex, column: { colId } }) => {
  const collect = () => ({
    rowIndex,
    rowData: data,
  });

  const isNoApproval = data.id === 'no_approval_lists';
  const divClassName = classNames('ag-cell ag-cell-not-inline-editing', {
    [style.marked]: isDeepChanged(data),
  });
  let content = null;

  if (colId === 'dateReceived' || colId === 'dateSent') {
    const date = value.value;

    content = <div className={divClassName}>{date && date.isValid() ? date.format('MM/DD/YYYY') : ''}</div>;
  } else if (colId === 'applistLabel') {
    content = <div className={divClassName}>{value.value}</div>;
  } else {
    content = <div className={divClassName}>{value}</div>;
  }

  if (isNoApproval) return <div className={style.noApproval}>{content}</div>;

  return (
    <ContextMenuTrigger collect={collect} id={colDef.contextMenuId}>
      {content}
    </ContextMenuTrigger>
  );
};

/** General format component. */
export const GeneralFormat = memo(GeneralFormatComponent);
